import * as React from 'react';
import styled, { withTheme } from 'styled-components';
import { rem } from 'polished';
import { FlexCol, FlexRow } from '../../Defaults/Flexbox/Flexbox';
import { TextP } from '../../Defaults/Text';
import { ButtonLink } from '../General/Button';
import { __ } from 'react-i18n';
import { Link } from 'react-router';

interface Props {
  image: string;
  url: string;
  type?: BannerType;
}

export enum BannerType {
  SERVIS = 'SERVIS',
  ASSEMBLING = 'ASSEMBLING',
  SERVIS_MAX = 'SERVIS_MAX',
}

function BannerWithImgButton({
  image,
  url,
  type = BannerType.ASSEMBLING,
}: Props) {
  if (type === BannerType.SERVIS || type === BannerType.SERVIS_MAX) {
    return (
      <ServisWrapper to={url} target="_blank" rel="noopener noreferrer">
        <ServisImage
          alt={__('Ponúkame montáž kachlí, krbov, záručný i pozáručný servis')}
          src={image}
        />
      </ServisWrapper>
    );
  }

  return (
    <Wrapper>
      <Image alt={__('Obrázok montáže krbu')} src={image} />
      <TextButtonWrapper>
        <Text>
          {__(
            'Zabezpečíme odbornú montáž vášho krbu, pece, kachlí vrátane pozáručného servisu',
          )}
        </Text>
        <InterestedButton to={url} target="_blank" rel="noopener noreferrer">
          {__('Mám záujem')}
        </InterestedButton>
      </TextButtonWrapper>
    </Wrapper>
  );
}

const ServisWrapper = styled(Link)`
  margin-top: ${rem(16)};
  transition: transform 0.2s ease;

  &:hover {
    transform: scale(1.02);
  }
`;

const ServisImage = styled.img`
  border-radius: ${rem(2)};
`;

const Wrapper = styled(FlexRow)`
  border: 0;
  border-radius: ${rem(2)};
  max-width: ${rem(820)};
  width: 100%;
  padding: 0;
  height: ${rem(190)};
  align-items: flex-end;

  ${({ theme }) => theme.mediab.l925`
    display: none;
  `}
`;

const Image = styled.img`
  height: ${rem(190)};
  max-width: ${rem(498)};
`;

const TextButtonWrapper = styled(FlexCol)`
  width: 50%;
  justify-content: center;
  background-color: #fbf4f2;
  height: ${rem(180)};
`;

const Text = styled(TextP)`
  font-size: ${rem(20)};
  line-height: ${rem(28)};
  font-family: ${({ theme }) => theme.font.primary};
  margin-bottom: ${rem(16)};
  max-width: ${rem(280)};
`;

const InterestedButton = styled(ButtonLink)`
  background-color: ${({ theme }) => theme.heatCategory.primary};
  color: white;
  max-width: ${rem(160)};
  border-radius: ${rem(2)};
`;

export { BannerWithImgButton };
